import { useMutation } from '@tanstack/react-query'
import { baseURL, headers } from '@/v2/constants/requests'

export const useChangePassword = () => {
  const { mutateAsync: changePassword, ...rest } = useMutation({
    mutationFn: async passwordData => {
      const res = await fetch(`${baseURL}/v2/rest/settings/password`, {
        method: 'PATCH',
        headers,
        body: JSON.stringify({ password_change: passwordData }),
      })
      if (!res.ok) {
        const error = await res.json()
        throw error
      }
    },
  })

  return { changePassword, ...rest }
}
